import React, { Component } from 'react';
import PropTypes from 'prop-types';

class EditDetailsButton extends Component {
    static propTypes = {
        isEditModeActive: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        isLoading: PropTypes.bool.isRequired
    };

  constructor(props) {
    super(props);
    this.state = {
        isEditModeActive: props.isEditModeActive,
        isLoading: props.isLoading
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isEditModeActive !== this.state.isEditModeActive) {
        this.setState({
            isEditModeActive: this.props.isEditModeActive
        });
    }
    if (this.props.isLoading !== this.state.isLoading) {
        this.setState({
            isLoading: this.props.isLoading
        });
    }
  }

  render() {
    const {
        isLoading,
        isEditModeActive
    } = this.props
    return (
        <button
            className={`edit-btn ${isEditModeActive ? 'active': ''}`} 
            onClick={() => this.props.onClick()} 
            disabled={isLoading}
        >
            <i className='las la-pen'></i>
        </button>    
    );
  }
}

export default EditDetailsButton;


// WEBPACK FOOTER //
// ./src/features/topics/components/edit-topic/EditDetailsButton.js